import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.2 2C13.1765 2 16.4 5.22355 16.4 9.2C16.4 10.8998 15.811 12.4621 14.8258 13.6937L17.7657 16.6343C18.0781 16.9467 18.0781 17.4533 17.7657 17.7657C17.4773 18.0541 17.0235 18.0763 16.7097 17.8322L16.6343 17.7657L13.6937 14.8258C12.4621 15.811 10.8998 16.4 9.2 16.4C5.22355 16.4 2 13.1765 2 9.2C2 5.22355 5.22355 2 9.2 2ZM9.2 3.6C6.10721 3.6 3.6 6.10721 3.6 9.2C3.6 12.2928 6.10721 14.8 9.2 14.8C12.2928 14.8 14.8 12.2928 14.8 9.2C14.8 6.10721 12.2928 3.6 9.2 3.6Z",
		fill: "#8895A7"
	})
});
export default SvgSearch;
